import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "../pages/Home/HomePage";
import SearchRoomsPage from "../pages/Search/SearchRoomsPage";
import RoomDetailsPage from "../pages/Details/RoomDetailsPage";
import MessagePage from "../pages/Chat/MessagePage";
import AddListingPage from "../pages/Owner/AddListingPage";
import RoomInquiryPage from "../pages/RoomInquiryPage/RoomInquiryPage";
import OwnerDashboardPage from "../pages/Owner/OwnerDashboardPage";
import SeekerDashboardPage from "../pages/Seeker/SeekerDashboardPage";
import ConfirmDealPage from "../pages/Deal/ConfirmDealPage";
import LoginPage from "../pages/Auth/LoginPage";
import RegisterPage from "../pages/Auth/RegisterPage";
import AdminDashboardPage from "../pages/Admin/AdminDashboardPage";
import NotFound from "../pages/NotFound";
import TermsConditionsPage from "../pages/Legal/TermsConditionsPage";
import AboutPage from "../pages/About/AboutPage";
import ContactPage from "../pages/Contact/ContactPage";
import VerifyEmail from "../pages/Auth/VerifyEmail";
import ResendVerification from "../pages/Auth/ResendVerification";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import ResetPassword from "../pages/Auth/ResetPassword";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/search" element={<SearchRoomsPage />} />
      <Route path="/room/:id" element={<RoomDetailsPage />} />
      <Route path="/messages" element={<MessagePage />} />

      {/* Role-based sections */}
      <Route path="/add-listing" element={<AddListingPage />} />
      <Route path="/add-listing/:id/edit" element={<AddListingPage />} />
      <Route path="/owner" element={<OwnerDashboardPage />} />
      <Route path="/seeker" element={<SeekerDashboardPage />} />
      <Route path="/admin" element={<AdminDashboardPage />} />

      {/* Deals & auth */}
      <Route path="/deal/:id" element={<ConfirmDealPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      {/* Email verification and password reset */}
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/resend-verification" element={<ResendVerification />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route path="/terms" element={<TermsConditionsPage />} />
      <Route path="/aboutus" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/roomInquiry" element={<RoomInquiryPage />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
